module.exports = __webpack_public_path__ + "assets/21a941804c63cb5f57d8b238fb147a87.png";